import React from 'react';
const BillingConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/billing',
			component: React.lazy(() => import('./Billing'))
		}
	]
};

export default BillingConfig;
